import { Action } from '../../../redux/redux.types';
import { TEAM_MEMBERS_ACTION_NAMES } from '../../team/team.actions';

import { PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES } from './project-overview-members.actions';

export interface ProjectOverviewMembersUiState {
  deletingMemberId: string | undefined;
  editingMemberId: string | undefined;
  isMemberAddModalOpened: boolean;
  isMemberDeleteModalOpened: boolean;
  isMemberEditModalOpened: boolean;
  isMembersListModalOpened: boolean;
}

export const projectOverviewMembersUiDefaultState: ProjectOverviewMembersUiState =
  {
    deletingMemberId: undefined,
    editingMemberId: undefined,
    isMemberAddModalOpened: false,
    isMemberDeleteModalOpened: false,
    isMemberEditModalOpened: false,
    isMembersListModalOpened: false,
  };

export const projectOverviewMembersUiState = (
  state: ProjectOverviewMembersUiState = projectOverviewMembersUiDefaultState,
  { type, payload }: Action,
): ProjectOverviewMembersUiState => {
  switch (type) {
    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_ADD_MEMBER_MODAL_FROM_MEMBERS_LIST_MODAL:
      return {
        ...state,
        isMemberAddModalOpened: true,
        isMembersListModalOpened: false,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_ADD_MEMBER_MODAL:
      return {
        ...state,
        isMemberAddModalOpened: true,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.CLOSE_ADD_MEMBER_MODAL:
    case TEAM_MEMBERS_ACTION_NAMES.CLOSE_ADD_MEMBER_MODAL:
      return {
        ...state,
        isMemberAddModalOpened: false,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_DELETE_MEMBER_MODAL:
      return {
        ...state,
        deletingMemberId: payload,
        isMemberDeleteModalOpened: true,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.CLOSE_DELETE_MEMBER_MODAL:
      return {
        ...state,
        deletingMemberId: undefined,
        isMemberDeleteModalOpened: false,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_EDIT_MEMBER_MODAL:
      return {
        ...state,
        editingMemberId: payload,
        isMemberEditModalOpened: true,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.CLOSE_EDIT_MEMBER_MODAL:
      return {
        ...state,
        editingMemberId: undefined,
        isMemberEditModalOpened: false,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_DELETE_MEMBER_MODAL_FROM_EDIT_MEMBER_MODAL:
      return {
        ...state,
        deletingMemberId: state.editingMemberId,
        editingMemberId: undefined,
        isMemberDeleteModalOpened: true,
        isMemberEditModalOpened: false,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_MEMBERS_LIST_MODAL_FROM_ADD_MEMBER_MODAL:
      return {
        ...state,
        isMemberAddModalOpened: false,
        isMembersListModalOpened: true,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_MEMBERS_LIST_MODAL:
      return {
        ...state,
        isMembersListModalOpened: true,
      };

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.CLOSE_MEMBERS_LIST_MODAL:
      return {
        ...state,
        isMembersListModalOpened: false,
      };

    default:
      return state;
  }
};
